export const INSTANCE_TYPE_NAME = 'Community';
export const SOMETHING_WRONG = 'Something went wrong';
export const MOBILE_WIDTH = 767;
export const VIEW_LAYOUT_ERROR_MESSAGE =
  'Error in fetching data. Please try again later.';
export const VIEW_LAYOUT_ERROR_MESSAGE_WHEN_ERROR_DETAILS_ARE_PRESENT =
  'Error in fetching data. Request failed with following Error: ';
export const INVALID_EMAIL_ERROR_MESSAGE = 'Please enter valid email id';
